// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-panel_card {\n  margin: 20px;\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
